/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BulkUpload } from "./BulkUpload";
import {
  BulkUploadFromJSON,
  BulkUploadFromJSONTyped,
  BulkUploadToJSON,
  BulkUploadToJSONTyped,
} from "./BulkUpload";

/**
 *
 * @export
 * @interface ApiBulkuploadsList200Response
 */
export interface ApiBulkuploadsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiBulkuploadsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiBulkuploadsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiBulkuploadsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<BulkUpload>}
   * @memberof ApiBulkuploadsList200Response
   */
  results: Array<BulkUpload>;
}

/**
 * Check if a given object implements the ApiBulkuploadsList200Response interface.
 */
export function instanceOfApiBulkuploadsList200Response(
  value: object
): value is ApiBulkuploadsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiBulkuploadsList200ResponseFromJSON(json: any): ApiBulkuploadsList200Response {
  return ApiBulkuploadsList200ResponseFromJSONTyped(json, false);
}

export function ApiBulkuploadsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiBulkuploadsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(BulkUploadFromJSON),
  };
}

export function ApiBulkuploadsList200ResponseToJSON(json: any): ApiBulkuploadsList200Response {
  return ApiBulkuploadsList200ResponseToJSONTyped(json, false);
}

export function ApiBulkuploadsList200ResponseToJSONTyped(
  value?: ApiBulkuploadsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(BulkUploadToJSON),
  };
}
